<template>
    <div class="famous-list-content">
        <div v-show="!gotData" class="layout-rl-note">正在加载数据...</div>
        <no-data
            v-show="gotData && !listData.length"
            v-bind:noteText="'还没有相关名人八字百科~'"
            v-bind:showButton="true"
            v-bind:buttonText="'马上去创建'"
            v-bind:buttonFunc="clickStartCollate">
        </no-data>
        <virtual-list
            ref="vsl"
            v-show="gotData && !!listData.length"
            id="FamousVirtualList"
            class="overflow-y-scroll scroll-touch"
            :data-key="'id'"
            :data-sources="listData"
            :data-component="itemComponent"

            :estimate-size="50"
            :item-class="'com-record-item-w90'"
            :footer-class="'famous-list-note'"
            v-on:tobottom="onScrollToBottom">
            <div v-show="parseInt(curPediaTotalData.nowpage) < parseInt(curPediaTotalData.totalpage) && !hideLoading" slot="footer" class="lds-dual-ring lds-dual-ring-gray"></div>
        </virtual-list>
    </div>
</template>

<script>
import NoData from '../../components/common/NoData.vue'
import FamousRecordItem from '../../components/famouspedia/FamousRecordItem.vue'
export default {
    name: 'FamousVirtualList',
    components: { NoData },
    props: {
        listData: {
            type: Array,
            default() { return [] }
        },
        gotData: {
            type: Boolean,
            default() { return false }
        },
        hideLoading: {
            type: Boolean,
            default() { return false }
        },
        startCollateFunc: {
            type: Function,
            default() { return null }
        }
    },
    computed: {
        curPediaMenuId() {
            return this.$store.state.famouspedia.curPediaMenuId;
        },
        curPediaTotalData() {
            return this.$store.state.famouspedia.curPediaTotalData;
        }
    },
    data() {
        return {
            itemComponent: FamousRecordItem,
        }
    },
    mounted() {
        this.$bus.on('scrollFamousToTop', this.scrollToTop)
    },
    destroyed() {
        this.$bus.off('scrollFamousToTop', this.scrollToTop)
    },
    methods: {
        clickStartCollate() {
            if(this.startCollateFunc && typeof(this.startCollateFunc) == 'function') {
                this.startCollateFunc();
            }
        },
        onScrollToBottom() {
            var me = this, actionStr = '';
            switch(this.curPediaMenuId) {
                case 1: actionStr = 'famouspedia/updateHotList'; break;
                case 2: actionStr = 'famouspedia/updateNewList'; break;
                case 3: actionStr = 'famouspedia/updateCollectList'; break;
                case 4: actionStr = 'famouspedia/updateMyList'; break;
                case 5: actionStr = 'famouspedia/updateGlanceList'; break;
                default: break;
            }
            if(actionStr != '') {
                this.$store.dispatch(actionStr);
            }
        },
        scrollToTop() {
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToIndex(0);
            }
        }
    }
}
</script>